import {
  createFileRoute,
} from '@tanstack/react-router';

import Register from '#features/auth/registration/Registration';

export const Route = createFileRoute('/_app/auth/register')({
  component: Register,
});
